import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
//import './Aa1HomePageStyle.css';

function Aa1HomePage() {

  const otpContainerRef = useRef([]);
  const [language, setLanguage] = useState('AR');
  const [msisdn, setMsisdn] = useState(null);
  const [warning, setWarning] = useState(false);
  const [otp, setOtp] = useState([null, null, null, null, null, null]);
  const [isGradient, setIsGradient] = useState(false);
  const [firstStep, setFirstStep] = useState(true);
  const [secondStep, setSecondStep] = useState(false);
  
  useEffect(() => {
    if (secondStep) 
    {
      otpContainerRef.current[0].focus();
    }
  }, [secondStep]); 


  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang === 'English' ? 'EN' : 'AR');
    setIsGradient(selectedLang === 'English' ? true : false);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to right, rgba(224,112,197,0.4) 50%, rgba(98,111,242,1) 50%)'
      : 'linear-gradient(to left, rgba(224,112,197,0.4) 50%, rgba(98,111,242,1) 50%)',
  };

  const handleMsisdnChange = (event) => {
    const newMsisdn = event.target.value;
    setMsisdn(newMsisdn);
    document.getElementById('country-code').style.color = 'black';
    setWarning(false);
  }

  const handleMsisdnFocus = () => {
    document.getElementById('country-code').style.color = 'black';
  }

  const handleMsisdnBlur = () => {
    if(msisdn === null || msisdn === undefined || msisdn.length === 0)
    {
      document.getElementById('country-code').style.color = '#999';
    }
  }

  const handleOtpChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    if (index < otp.length - 1 && value !== '') {
      otpContainerRef.current[index + 1].focus();
    }
    setOtp(newOtp);
  };

  const handleSubscribeClick = () => {
    if(!isMsisdnValid())
    {
      document.getElementById('warning-msg').textContent = language === 'EN' ? 'Incorrect Number Format' : 'رقم غير صحيح';
      setWarning(true);
      return;
    }

    setWarning(false);
    setFirstStep(false);
    setSecondStep(true);
    document.getElementById('msisdn-input').style.display = 'none';
    document.getElementById('otp-input').style.display = 'flex';
    document.getElementById('title').textContent = language === 'EN' ? 'Enter your OTP' : 'ادخل الرقم السري';
  }

  const isMsisdnValid = () => {
    if(msisdn !== null && msisdn !== undefined)
    {
      return ( (msisdn.length === 10 && msisdn.startsWith('05')) || (msisdn.length === 9 && msisdn.startsWith('5')) );
    }
    return false;
  }

  return (
    <div className="Aa1">
      <div className='container'>
        <div className='header'>
          <div className='header-left'>
            <div className="language" style={gradientStyle} onClick={handleLanguage}>
              <div className='language-left'>
                <span>عربي</span>
              </div>
              <div className='language-middle'>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              </div>
              <div className='language-right'>
                <span>English</span>
              </div>
            </div>
          </div>
          <div className='header-right'>
            <div className='logo'><img fetchpriority='high' alt='Kid Security' src='/kid-security-logo-en.avif'/></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='form-content-top'>
            <div className='logo'><img fetchpriority='high' alt='Kid Security' src='/download-icon.avif'/></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h4 id='title'>{secondStep ? 
                (language === 'EN' ? 'Enter your OTP' : 'ادخل الرقم السري') : 
                (language === 'EN' ? 'Enter your mobile number' : 'ادخل رقم هاتفك المحمول') }</h4>
            </div>
            <div id='msisdn-input' className={`input ${warning ? 'vibrate' : ''}`}>
              <span id='country-code' className='country-code'>+966</span>
              <input type='tel' value={msisdn} placeholder='05xxxxxxxx' autoComplete='off' minLength={9} maxLength={10} required onChange={handleMsisdnChange} onFocus={handleMsisdnFocus} onBlur={handleMsisdnBlur} />
              <div className='phone-logo'>
                <svg width="60px" height="60px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><path fill="#F8D6C1" d="M12.2 10c-1.1-0.1-1.7 1.4-2.5 1.8-1.3 0.7-3.7-1.8-3.7-1.8s-2.5-2.4-1.9-3.7c0.5-0.8 2-1.4 1.9-2.5-0.1-1-2.3-4.6-3.4-3.6-2.4 2.2-2.6 3.1-2.6 4.9-0.1 3.1 3.9 7 3.9 7 0.4 0.4 3.9 4 7 3.9 1.8 0 2.7-0.2 4.9-2.6 1-1.1-2.5-3.3-3.6-3.4z"></path></svg>
              </div>
            </div>
            <div className={`warning-msg ${warning ? 'active' : ''}`}>
              <span id="warning-msg">&nbsp;</span>
            </div>
            <div id='otp-input' className='otp-input-container'>
              {otp.map((digit, index) => (
                <input key={index} id={`otp-input-${index}`} type="tel" maxLength="1" value={digit} 
                onChange={(e) => handleOtpChange(index, e.target.value)} className="otp-input" autoComplete="off" ref={(input) => (otpContainerRef.current[index] = input)}/>
              ))}
            </div>
            <div className='button'>
              <button id='subscribe-btn' onClick={handleSubscribeClick}>{language === 'EN' ? 'Subscribe' : 'اشتـرك'}</button>
              <span>{language === 'EN' ? '1 rial/day' : '١ ريال/يوم'}</span>
            </div>
          </div>
          <div className='form-content-bottom' style={{direction:"rtl"}}>
            {language === 'EN' ? <span>
              Kid Security is a subscription service available for STC users
              that costs 1 Riyal renewed daily for prepaid subscribers and
              costs 34.5 Riyals renewed monthly for postpaid subscribers
              (VAT Included) 
              To unsubscribe send U 1 to 802460, VAT Tax was already paid
              with a refill card for prepaid subscribers.<br></br>
              For Mobily Subscribers the service price is 1.15 Riyal daily with
              a 1-day free trial for the first subscription(VAT Included). 
              VAT Tax was already paid with a refill card for prepaid
              subscribers. and to unsubscribe send U 58 to 607110
            </span> : <span>
            امان الأطفال هي خدمة اشتراك متوفرة لعملاء شركة الاتصالات السعودية مقابل
             ١ ريال لعملاء مسبق الدفع تتجدد يومي وبمقابل ٣٤.٥ ريال لعملاء المفوتر تتجدد 
            شهري (شامل قيمة الضريبة المضافة) ولإلغاء الاشتراك الرجاء ارسال غ ١ الى
            802460 
            .تم تحصيل مبلغ الضريبة المضافة لعملاء مسبق الدفع عند عملية شحن الرصيد
            <br></br>لمشتركين موبايلي سعر الخدمة ١.٥١ ريال يوميا مع تجربة مجانية ليوم واحد عند
            اشتراكك اول مره (شامل قيمة الضريبة المضافة).
            تم تحصيل مبلغ الضريبة لعملاء مسبق الدفع عند عملية شحن الرصيد. ولإلغاء * *
            .الاشتراك أرسل غ ٥٨ إلى 607110
            </span>}
          </div>
          <div className='form-content-footer'>
            <Link to={`/aa1/terms?lang=${language}`}>{language === 'AR' ? (<a>أحكام وشروط</a>) : (<a>Terms and Condition</a>)}</Link>
            <svg fill="#000000" width="1em" height="1em" viewBox="-6.5 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M8.469-1.156h2.25v29.813h-2.25v-29.813z"></path></svg>
            {language === 'AR' ? (<a href='mailto:support@kid-security.io'>للتواصل انقر هنا</a>) : (<a href='mailto:support@kid-security.io'>Contact Us</a>)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aa1HomePage;